import { inject, injectable } from 'tsyringe';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import { type ICompanyChatRepository } from 'application/repositorySchemas/ICompanyChatRepository';
import { type ICompanySendChatClient } from 'interfaceAdapter/gatewaySchemas/ICompanySendChatClient';
import { type ICompanySetMeetingDateClient } from 'interfaceAdapter/gatewaySchemas/ICompanySetMeetingDateClient';
import { type ICompanyDeclineMeetingDateClient } from 'interfaceAdapter/gatewaySchemas/ICompanyDeclineMeetingDateClient';
import { type ICompanyConfirmMeetingDateClient } from 'interfaceAdapter/gatewaySchemas/ICompanyConfirmMeetingDateClient';

@injectable()
export class CompanyChatRepository implements ICompanyChatRepository {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('ICompanySendChatClient')
        public readonly sendChatClient: ICompanySendChatClient,
        @inject('ICompanySetMeetingDateClient')
        public readonly setMeetingDateClient: ICompanySetMeetingDateClient,
        @inject('ICompanyDeclineMeetingDateClient')
        public readonly declineMeetingDateClient: ICompanyDeclineMeetingDateClient,
        @inject('ICompanyConfirmMeetingDateClient')
        public readonly confirmMeetingDateClient: ICompanyConfirmMeetingDateClient,
    ) {}

    public async send(chat_room_id: number, message: string) {
        const { data, message: resMessage } = await this.sendChatClient.post({
            token: this.companyUserToken.get() || '',
            chat_room_id,
            message,
        });

        if (resMessage) {
            throw new Error(resMessage);
        }

        return data;
    }

    public async setMeetingDate(match_id: number, meeting_date: string) {
        const { data, message } = await this.setMeetingDateClient.post({
            token: this.companyUserToken.get() || '',
            match_id,
            meeting_date,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    public async declineMeetingDate(match_id: number) {
        const { data, message } = await this.declineMeetingDateClient.post({
            token: this.companyUserToken.get() || '',
            match_id,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    public async confirmMeetingDate(match_id: number) {
        const { data, message } = await this.confirmMeetingDateClient.post({
            token: this.companyUserToken.get() || '',
            match_id,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
